import { render, staticRenderFns } from "./Block1Vue.vue?vue&type=template&id=526fcd9d&scoped=true"
import script from "./Block1Vue.vue?vue&type=script&lang=js"
export * from "./Block1Vue.vue?vue&type=script&lang=js"
import style0 from "./Block1Vue.vue?vue&type=style&index=0&id=526fcd9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526fcd9d",
  null
  
)

export default component.exports